import { useStudyProgram } from "./useStudyProgram";
import { useStudyProgramsByCourse } from "./useStudyProgramsByCourse";

export { useStudyProgram, useStudyProgramsByCourse };
